const getGenres = async () => {
    const response = await fetch('/genres.txt');
    const genres = await response.text();
    return genres.split('\n');
}

export default getGenres;